export function getFormioFileI18n() {
  return {
    en: {
      'File Name': 'File Name',
      'Size': 'Size',
      'Type': 'Type',
      'Gallery': 'Gallery',
      'Camera': 'Camera',
      'Drop files to attach,': 'Drop files to attach,',
      'use camera': 'use camera',
      'or': 'or',
      'browse': 'browse',
      'Any file types are allowed': 'Any file types are allowed',
      'Allowed file types: {{filePattern}}': 'Allowed file types: {{filePattern}}',
      'Browse to attach file for {{label}}. {{description}}{{fileTypesMessage}}': 'Browse to attach file for {{label}}. {{description}}{{fileTypesMessage}}',
      'Take Picture': 'Take Picture',
      'Switch to file upload': 'Switch to file upload',
      'Remove button. Press to remove {{fileName}}.': 'Remove button. Press to remove {{fileName}}.',
      'Complete': 'Complete',
      'No storage has been set for this field. File uploads are disabled until storage is set up.': 'No storage has been set for this field. File uploads are disabled until storage is set up.',
      'File API & FileReader API not supported.': 'File API & FileReader API not supported.',
      'XHR2\'s FormData is not supported.': 'XHR2\'s FormData is not supported.',
      'XHR2\'s upload progress isn\'t supported.': 'XHR2\'s upload progress isn\'t supported.',
    },
    uk: {
      'File Name': 'Назва файлу',
      'Size': 'Розмір',
      'Type': 'Тип',
      'Gallery': 'Галерея',
      'Camera': 'Камера',
      'Drop files to attach,': 'Перетягніть файли, щоб прикріпити,',
      'use camera': 'використати камеру',
      'or': 'або',
      'browse': 'оберіть',
      'Any file types are allowed': 'Дозволені будь-які типи файлів',
      'Allowed file types: {{filePattern}}': 'Дозволені типи файлів: {{filePattern}}',
      'Browse to attach file for {{label}}. {{description}}{{fileTypesMessage}}': 'Оберіть файл для поля {{label}}. {{description}}{{fileTypesMessage}}',
      'Take Picture': 'Зробити фото',
      'Switch to file upload': 'Переключитися на завантаження файлу',
      'Remove button. Press to remove {{fileName}}.': 'Кнопка видалення. Натисніть, щоб видалити {{fileName}}.',
      'Complete': 'Завершено',
      'No storage has been set for this field. File uploads are disabled until storage is set up.': 'Для цього поля не налаштовано сховище. Завантаження файлів вимкнено, доки сховище не буде налаштовано.',
      'File API & FileReader API not supported.': 'File API та FileReader API не підтримуються.',
      'XHR2\'s FormData is not supported.': 'FormData у XHR2 не підтримується.',
      'XHR2\'s upload progress isn\'t supported.': 'Відстеження прогресу завантаження в XHR2 не підтримується.',
    },
  }
}